
export const images = [

]

for (var i = 1; i <= 31; i++) {
    images.push(`format${i}.jpg`)
}

